import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import {
  Form,
  FormInput,
  FormSubmitButton,
  Button,
  FormResetButton,
  notification,
  Row,
  Col,
  FormSwitch,
  useRouter,
} from '@digital/ui';
import { useActions } from '@digital/ui/lib/store';
import { Layout, Card } from 'antd';
import * as Yup from 'yup';

import LoginHeaderLogo from '../../../public/images/icone_mrn.png';
import LoginBoxLogo from '../../../public/images/logo_mrn_verde.svg';
import { loginFornecedor, forgotPassword, getPermissions } from '../../api/account';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { getUrlUsuario } from '@app/helpers';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import './custom.css';
import packageJson from 'package.json';
import Microsoft from '../../../public/images/microsoft.png';
import { loginRequest } from '@app/config/msalConfig';
import { useMsal } from '@azure/msal-react';
import { setAuthorizationToken } from '@app/api/api';
import { InteractionStatus } from '@azure/msal-browser';
import AuthRedirect from './AuthRedirect';
interface LoginProps {
  isAuthenticated: boolean;
  onAuthenticate: (isAuthenticated: boolean) => void;
}

const Login = ({ isAuthenticated, onAuthenticate }: LoginProps) => {
  const { instance } = useMsal();
  const { history } = useRouter();
  const params = new URLSearchParams(location.search);

  const loadPermissions = useActions((state: any) => state.permission.loadPermissions);
  const [trocarSenha, setTrocarSenha] = useState<boolean>();
  const [isLoading, setIsLoading] = useState<boolean>();
  const [emailData, setEmailData] = useState({});
  const [username, setUsername] = useState<string | undefined>(undefined);
  const [saveUsername, setSaveUsername] = useState(localStorage.getItem('saveUsername') === 'true');

  const [token, setToken] = useState('');
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const handleMicrosoftLogin = () => {
    console.log('[SSO] Iniciando login Microsoft (redirect)');

    instance.loginRedirect({
      scopes: ['openid', 'profile', 'email', 'api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'],
    });
  };

  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    const resp = await loginFornecedor({ ...values, username, token });
    if (resp && resp.valid) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('isMRN', resp.isMRN);
      localStorage.setItem('codigoUsuario', resp.codigoUsuario);
      localStorage.setItem('idtoken', resp.access_token);
      localStorage.setItem('expiration', resp.expires_in);
      if (resp.url) {
        localStorage.setItem('url', resp.url);
      } else {
        localStorage.removeItem('url');
      }

      if (localStorage.getItem('saveUsername') === 'true') {
        localStorage.setItem('username', username);
      } else {
        localStorage.removeItem('username');
      }
      if (resp.isFirstAccess == true) {
        loadPermissions(['dfc2fd92-3024-4641-9219-ea357a4eeeb3']);
        window.location.href = '/primeiroAcesso';
      } else {
        onAuthenticate(true);
        loadPermissions(resp.permissoes);

        const redirect = isObjNotEmpty(params.get('redirect'))
          ? params.get('redirect')
          : resp.url || getUrlUsuario() || '/';

        console.log(redirect);
        // history.push(redirect || "");
        window.location.href = redirect || '';
      }
    } else {
      setRefreshReCaptcha(!refreshReCaptcha);
      setIsLoading(false);
    }
  };

  const handleForgotPassword = (values: any) => {
    setIsLoading(true);
    forgotPassword(values.userName).then((res: any) => {    
      if(res && res.valid) 
        notification.success('O link de redefinição de senha foi enviado para o e-mail cadastrado, caso exista em nossa base.');
        setEmailData({ nome: ' ' });
        setEmailData({});
        setTrocarSenha(false);
    }).catch((error) => {
      console.error('Erro no forgotPassword:', error);
      notification.error('Não foi possível processar sua solicitação.');
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  const handleTrocarSenha = () => {
    setTrocarSenha(!trocarSenha);
  };

  useEffect(() => {
    if (localStorage.getItem('saveUsername') === 'true' && localStorage.getItem('username') != null) {
      setUsername(localStorage.getItem('username'));
    }
  }, []);

  const verifyRecaptchaCallback = React.useCallback(token => {
    // console.log('verifyRecaptchaCallback', process.env.REACT_APP_RECAPTCHA_KEY, "\n", token);
    setToken(token);
  }, []);

  const { inProgress } = useMsal();

  const isLoggingIn = inProgress === InteractionStatus.HandleRedirect || inProgress === InteractionStatus.SsoSilent;

  if (isLoggingIn ) {
    return <AuthRedirect />;
  }

  const redirectUrl = getUrlUsuario() || '/';

  return (
    <>
      {isAuthenticated ? (
        isObjNotEmpty(params.get('redirect')) ? (
          <Redirect to={params.get('redirect') || '/'} />
        ) : (
          <Redirect to={redirectUrl} />
        )
      ) : (
        <>
          <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY || ''}>
            <GoogleReCaptcha
              className="google-recaptcha-custom-class"
              onVerify={verifyRecaptchaCallback}
              refreshReCaptcha={refreshReCaptcha}
            />
          </GoogleReCaptchaProvider>
          {
            <style
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `header.ant-app-header.ant-layout-header {background-color: #161616; display: block !important;} .ant-app-header-actions .ant-btn i.icon {color:#D0D0D0} .ant-app-header-actions .ant-btn i.icon:hover {color:#FFFFFF} .ant-app-header-actions .ant-btn:hover i.icon, .ant-app-header-actions .ant-btn:focus i.icon {padding: 0px; color: #FFFFFF; background-color: transparent; border-color: transparent;} .ant-app-header .ant-app-header-logo span {height: 48px; display: flex; align-items: center} .ant-app-header-logo > .anticon {display:none} .ant-app-header-title:before {content: url(${LoginHeaderLogo}); height: 28px; margin-left: 2px} header.ant-app-header.ant-layout-header{display:none !important}`,
              }}
            />
          }
          <div className="login-view">
            <Layout>
              <div className="image">
                {/* <div className="login-greetings">
              <Title level={2}>SGC - Sistema de Gestão de Contratos</Title>
              <Title level={3}>Entre com suas credenciais para acessar o sistema.</Title>
            </div> */}
              </div>
              {/* <Card title={IMAGEM}> */}
              <Card>
                {trocarSenha ? (
                  <Form
                    initialValues={emailData}
                    validationSchema={Yup.object().shape({
                      userName: Yup.string().required('Nome do usuário deve ser informado'),
                    })}>
                    <div className="login-box">
                      <div className="login-box-logo">
                        <img src={LoginBoxLogo} />
                      </div>
                      <div className="login-box-title forgot-password">Recuperar Senha</div>
                    </div>
                    <FormInput name="userName" label="Usuário (Username)" />
                    <div className="actions">
                      <FormResetButton title="Cancelar" type="link" noIcon onClick={() => setTrocarSenha(false)} />
                      <FormSubmitButton
                        onClick={handleForgotPassword}
                        loading={isLoading}
                        title="Enviar"
                        noIcon
                        type="primary"
                        htmlType="submit"
                      />
                    </div>
                  </Form>
                ) : (
                  <Form
                    onSubmit={handleSubmit}
                    validationSchema={Yup.object().shape({
                      password: Yup.string().required('Campo requerido.'),
                      username: Yup.string().test('testRequiredUsername', '', function (value) {
                        if (username === undefined || username === '') {
                          return this.createError({ message: 'Campo requerido.' });
                        }
                        return true;
                      }),
                    })}>
                    <div className="login-box">
                      <Row>
                        <Col>
                          <div className="login-box-logo">
                            <img src={LoginBoxLogo} />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="login-box-group">
                            <h2 className="login-box-title-sig">SGC </h2>
                            <div className="login-box-title">Sistema de Gestão de Contratos v{packageJson.version}</div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <FormInput
                      id={'mrn-input-username'}
                      value={username}
                      onChange={e => setUsername(e.target.value)}
                      className="login-user-name"
                      name="username"
                      // required label="ui.commons.user"
                      placeholder="Informe o seu usuário"
                    />
                    <FormInput
                      id={'mrn-input-password'}
                      className="login-user-password"
                      name="password"
                      type="password"
                      // label="ui.commons.password"
                      placeholder="Informe sua senha"
                    />

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }} className="actions">
                      <FormSubmitButton
                        id={'mrn-btn-submit'}
                        title="Entrar"
                        loading={isLoading}
                        noIcon
                        type="primary"
                        htmlType="submit"
                      />{' '}
                      <Button title="Esqueceu a senha?" type="link" onClick={handleTrocarSenha} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                          fontSize: 12,
                          margin: '4px 0',
                        }}>
                        ————— ou —————
                      </div>
                      <Button
                        type="primary"
                        onClick={handleMicrosoftLogin}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 8,
                        }}>
                        <img src={Microsoft} alt="Microsoft" style={{ height: 18 }} />
                        Entrar com Microsoft
                      </Button>
                    </div>
                  </Form>
                )}
              </Card>
            </Layout>
          </div>
        </>
      )}
    </>
  );
};

export default Login;
